export default {
  getAllProducts(state) {
      return state.products;
    },
    hasProducts(state) {
      return state.allProducts && state.allProducts.length > 0;
    },
    getQuickEditStatus(state){
      return state.quickEditActive;
    }
    
  
  };
  